import { WebsiteResource } from './website/resource';
import { CmsPageResource } from './page/resource';
import { CmsStructureResource } from './structure/resource';
import { CmsImageResource } from './image/resource';
import { CmsLinkListResource } from './linklist/resource';
import { CmsStructureContentResource } from './structureContent/resource';

export const Resources = {
  Website: WebsiteResource,
  CmsPage: CmsPageResource,
  CmsStructure: CmsStructureResource,
  CmsImage: CmsImageResource,
  CmsLinkList: CmsLinkListResource,
  CmsStructureContent: CmsStructureContentResource,
};

export function getCmsResourceDef(id) {
  return Resources[id] ?? null;
}
